const environment = {
  guestyApi: 'https://app.guesty.com/api/v2',
  guestyApi2: 'https://groot-mailer.production.guesty.com/api/v2',
  pordalApi: 'https://o-api.dev.frankportertech.com',
  ownerApi: 'https://testfp.dev.frankportertech.com/owner/api/owner_api',
  frankPorterApi: 'https://testfp.dev.frankportertech.com',
  apiKey: 'KdDnXIZcVp0HBF2pzzVDHvNqE0CwxVnp',
  guestyApiKey: '957764c55f336af66b31bc12d7a3b7ad',
  guestyApiSecret: '36cb292533280c2790b2fe9ca419b49f',
  apiUsername: 'FP-Owner',
  apiPassword: 'QXGF4Zr84QoP)fRZa',
  accountId: '5b686412cdbb89003d8323b6',
  timeFormat: 'hh:mm A',
  timeFormatRU: 'HH:mm',
  pageSize: 999,
  isSentryEnabled: true,
  sentryDsn: 'https://9f7f3d93d5e74be1ab6f2faa7e746a5b@o1068165.ingest.sentry.io/6369981',
  sentrySampleRate: 1.0,
  pordalAppClient: 't35tcl13nt',
};

export default environment;
